import React from 'react';
import classnames from 'classnames';

import { Input, Props as InputProps } from '@/components/Input';
import { Icon, Type } from '@/components/Icon';
import { withValidation } from '@/components/hoc/withValidation';
import { Label } from '@/components/Label';

const style = {
  invalid: 'border-red transition ease-in-out',
  withTrail: 'pr-11'
};

export interface Props extends InputProps {
  invalid?: boolean;
  label?: string;
  leadingIcon?: Type;
  icon?: Type;
  onIconClick?: () => any;
  inputClassName?: string;
  required?: boolean;
}

export const TextInput = (props: React.PropsWithChildren<Props>) => {
  const {
    invalid,
    className,
    inputClassName,
    label,
    icon,
    leadingIcon,
    onIconClick,
    required = false,
    id,
    ...rest
  } = props;

  return (
    <div className={classnames('relative w-full inline-flex flex-col', { 'text-gray-dark': rest.disabled }, className)}>
      {label && (
        <div className="text-xs">
          <Label htmlFor={id}>{label}</Label>

          {required && <span className="text-red ml-1">*</span>}
        </div>
      )}

      <Input
        className={classnames(
          'relative box-border h-12 px-4 py-2 border border-solid rounded text-sm transition focus:border-scarlet ',
          {
            'border-gray-600': !invalid,
            'border-red': invalid,
            // [style.withLead]: leadingIcon,
            [style.withTrail]: icon
          },
          inputClassName
        )}
        {...{ id, ...rest }}
      />

      {icon && (
        <Icon
          type={icon}
          onClick={onIconClick}
          className={classnames(
            'h-10 absolute flex items-center hover:text-gray-darker bottom-0 text-gray-dark right-4',
            {
              [style.invalid]: invalid,
              'cursor-pointer': !!onIconClick
            }
          )}
        />
      )}
    </div>
  );
};

export const TextInputWithValidation = withValidation(TextInput);
